import React from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { Card, CardBody, CardTitle, Col, CardHeader } from "reactstrap";

const ServiceSubmitDateRange = ({
        valueDateRange,
        setValueDateRange,
        isSubmitting = false,
    }) => {
        return (
            <Col xs={12} md="auto">
                <Card className="h-100" style={{ minWidth: "28vw" }}>
                    <CardHeader>
                        <CardTitle tag="h4">Service Date Range</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <div className="service-date-range-row">
                            <DateRangePicker
                                disabled={isSubmitting}
                                rangeDivider=" : "
                                className="form-logs-input-date"
                                value={valueDateRange}
                                onChange={(range) => {
                                    if (range && range[0] instanceof Date && range[1] instanceof Date) {
                                        setValueDateRange(range);
                                    }
                                }}
                                format="y-MM-dd"
                                maxDate={new Date()}
                            />
                        </div>
                    </CardBody>
                </Card>
            </Col>
        );
};

export default ServiceSubmitDateRange;
